/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { RectProps } from './Shapes.types';

export const Rect = ({ x, y, width, height, scaleX, scaleY, tx, ty, fill, stroke }: RectProps) => {
  return (
    <rect
      x={x + tx}
      y={y + ty}
      width={width * scaleX}
      height={height * scaleY}
      fill={fill}
      stroke={stroke}
      strokeWidth={2}
      vectorEffect="non-scaling-stroke"
    />
  );
};
